import React from "react";
import "./launch-pages.css";
const email = "valentinsaez@yahoo.fr";
export function SiteFooter() {
  return (
    <footer className="site-footer">
      <a href="#contact">Contact</a>
      <a href="#mentions-legales">Mentions légales</a>
      <a href="#confidentialite">Confidentialité</a>
      <a href="#stockage-local">Cookies et stockage local</a>
    </footer>
  );
}
export default function InfoPage({ page }) {
  return (
    <>
      <main className="info-page fade-in">
        <a href="#accueil">← Retour au site</a>
        {page === "contact" ? (
          <>
            <span
              className="section-tag"
              style={{ display: "block", marginTop: 32 }}
            >
              ON GARDE LE CONTACT
            </span>
            <h1>Une question ? Une idée ?</h1>
            <p className="info-lead">
              Une énigme te semble incorrecte, ton compte est bloqué ou tu as
              une suggestion ? Écris-moi.
            </p>
            <section className="card">
              <h2>Contacter Valentin</h2>
              <p>BrainteaserDay est édité par Valentin SAEZ.</p>
              <a
                className="contact-link"
                href={"mailto:" + email + "?subject=BrainteaserDay"}
              >
                {email}
              </a>
              <p>
                Le lien ouvre ta messagerie. Tu peux aussi copier l’adresse pour
                écrire depuis ton service habituel.
              </p>
            </section>
            <section className="card">
              <h2>Pour que je puisse t’aider</h2>
              <p>
                Pour une énigme, indique sa date et son thème. Pour un problème
                technique, décris ce qui se passe et le navigateur utilisé. Ne
                communique jamais ton mot de passe ni ton lien de récupération.
              </p>
              <p>
                Pour retrouver l’accès à ton compte, tu peux aussi{" "}
                <a href="#mot-de-passe-oublie">
                  demander un nouveau mot de passe
                </a>
                .
              </p>
            </section>
            <section className="card">
              <h2>Tes données personnelles</h2>
              <p>
                Pour demander l’accès, la correction ou la suppression de tes
                données, écris à la même adresse depuis l’e-mail associé à ton
                compte.{" "}
                <a href="#confidentialite">
                  Consulter la politique de confidentialité
                </a>
                .
              </p>
            </section>
          </>
        ) : page === "stockage-local" ? (
          <>
            <h1>Cookies et stockage local</h1>
            <p className="info-lead">
              Comprendre ce que BrainteaserDay mémorise dans ton navigateur.
            </p>
            <section className="card">
              <h2>Rester connecté et choisir son thème</h2>
              <p>
                Le navigateur conserve un jeton de connexion pour accéder à ton
                compte, ainsi que ton choix de thème clair ou sombre. Le jeton
                expire au bout de sept jours ; il est retiré du navigateur
                lorsque tu te déconnectes. Une réinitialisation de mot de passe
                invalide également tes anciennes sessions.
              </p>
              <p>
                Le choix du thème reste enregistré jusqu’à ce que tu l’effaces
                dans les paramètres de ton navigateur.
              </p>
            </section>
            <section className="card">
              <h2>Le cache du site</h2>
              <p>
                Certains fichiers du site peuvent être mis en cache pour
                accélérer son ouverture et afficher une page lorsque la
                connexion est indisponible. Tu peux effacer ces fichiers dans
                les paramètres de données du site de ton navigateur.
              </p>
              <p>
                Effacer les données locales te déconnecte, mais ne supprime pas
                ton compte ni ta progression enregistrée sur le serveur.
              </p>
            </section>
            <section className="card">
              <h2>Services externes</h2>
              <p>
                Les polices d’écriture sont chargées depuis Google Fonts.
                L’ouverture du site établit donc une connexion avec ce service,
                auquel sont transmis les éléments techniques nécessaires à cette
                requête, notamment ton adresse IP.
              </p>
              <a href="#confidentialite">
                En savoir plus sur les destinataires des données
              </a>
            </section>
          </>
        ) : (
          <>
            <h1>Politique de confidentialité</h1>
            <p className="info-lead">
              Les données utiles pour jouer, enregistrer ta progression et
              protéger ton compte.
            </p>
            <p className="recovery-hint">
              Dernière mise à jour : 8 septembre 2026.
            </p>
            <section className="card">
              <h2>Qui est responsable ?</h2>
              <p>
                Valentin SAEZ est responsable des traitements de données de
                BrainteaserDay. Pour toute question :{" "}
                <a href={"mailto:" + email}>{email}</a>.
              </p>
            </section>
            <section className="card">
              <h2>Les données utilisées et leur rôle</h2>
              <ul>
                <li>
                  <strong>Compte :</strong> adresse e-mail, pseudonyme et
                  empreinte du mot de passe, pour créer ton compte et te
                  connecter.
                </li>
                <li>
                  <strong>Profil :</strong> biographie, couleur et photo
                  choisies, pour personnaliser ta présence sur le site.
                </li>
                <li>
                  <strong>Jeu :</strong> réponses, progression, XP, succès,
                  carnet et résultats de Course, pour assurer le fonctionnement
                  des défis et du classement.
                </li>
                <li>
                  <strong>Communauté :</strong> publications et réponses sur le
                  forum.
                </li>
                <li>
                  <strong>Assistance et sécurité :</strong> messages de contact,
                  informations techniques de connexion et demandes de
                  récupération de mot de passe.
                </li>
              </ul>
              <p>
                Le compte, le jeu et les fonctionnalités demandées reposent sur
                l’exécution du service. La prévention des abus, la sécurité et
                le traitement des demandes d’assistance reposent sur l’intérêt
                légitime à exploiter un service fiable.
              </p>
            </section>
            <section className="card">
              <h2>Ce qui est visible des autres joueurs</h2>
              <p>
                Ton pseudonyme, ta photo, ta biographie, les informations
                publiques de progression et tes contributions au forum sont
                visibles sur le site. Ton adresse e-mail et ton mot de passe ne
                sont pas affichés sur ton profil public. Évite les informations
                sensibles dans ta biographie et tes messages.
              </p>
            </section>
            <section className="card">
              <h2>Les destinataires</h2>
              <p>
                Valentin SAEZ accède aux données nécessaires à l’administration
                et à l’assistance. Le site est servi par Vercel et le backend
                conserve les données dans PostgreSQL sur un VPS OVHcloud. Brevo
                assure l’envoi des e-mails de récupération ; ce service reçoit
                l’adresse destinataire et le message contenant le lien
                temporaire. Les messages adressés au contact arrivent dans la
                messagerie Yahoo de l’éditeur.
              </p>
              <p>
                Google Fonts fournit les polices d’écriture. Ces prestataires
                traitent les données techniques nécessaires à leur intervention.
                Selon leurs infrastructures, certains traitements peuvent avoir
                lieu hors de l’Union européenne ; leurs conditions de protection
                des données décrivent les garanties applicables.
              </p>
            </section>
            <section className="card">
              <h2>Durée de conservation</h2>
              <p>
                Les données de compte, de profil et de progression sont
                conservées pour permettre l’utilisation du compte et son suivi
                dans le temps. Tu peux demander leur suppression. Les messages
                du forum restent publiés tant qu’ils n’ont pas été supprimés par
                leur auteur ou la modération.
              </p>
              <p>
                Un lien de récupération expire après 30 minutes. Il devient
                inutilisable dès son utilisation ou après une nouvelle demande
                acceptée. Les empreintes des liens expirés sont purgées toutes
                les heures et les états temporaires des courses après 24 heures.
                Le jeton de connexion expire après sept jours.
              </p>
              <p>
                Les demandes d’assistance sont conservées le temps de leur
                traitement et des suites nécessaires. L’éditeur ne conserve
                actuellement pas de copies de sauvegarde ni d’archives de
                journaux serveur. Les prestataires peuvent traiter leurs propres
                journaux techniques selon leurs politiques respectives.
              </p>
            </section>
            <section className="card">
              <h2>Exercer tes droits</h2>
              <p>
                Selon les conditions applicables, tu peux demander l’accès, la
                rectification, l’effacement, la limitation du traitement, la
                portabilité de tes données ou t’opposer aux traitements fondés
                sur l’intérêt légitime. Écris à{" "}
                <a href={"mailto:" + email}>{email}</a>. Une vérification
                proportionnée de ton identité peut être nécessaire pour protéger
                ton compte.
              </p>
              <p>
                Tu peux également adresser une réclamation à la{" "}
                <a
                  href="https://www.cnil.fr/fr/plaintes"
                  target="_blank"
                  rel="noreferrer"
                >
                  CNIL
                </a>
                .
              </p>
            </section>
            <section className="card">
              <h2>Dans ton navigateur</h2>
              <p>
                <a href="#stockage-local">
                  Consulter les informations sur les cookies, le stockage local
                  et le cache.
                </a>
              </p>
            </section>
          </>
        )}
      </main>
      <SiteFooter />
    </>
  );
}
